import TextareaInput from "components/common/InputField/TextareaInput";
import ToggleInput from "components/common/InputField/ToggleInput";
import React, { useEffect, useState } from "react";
import Tabs from "./tabs";
import Button from "components/common/Button";
import { workforceActions } from "redux/Ldb/actions";
import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import SelectInput from "components/common/InputField/SelectInput";
import MultiselectInput from "components/common/InputField/MultiselectInput";
import useGetTeam from "hooks/teamHooks/useGetTeamList";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "components/common/Loader";
import { useNavigationHandler } from "hooks/useNavigationHandler";

const Settings = ({
    setActiveTab,
    activeTab,
}: {
    setActiveTab: (tab: number) => void;
    activeTab: number;
}) => {
    const dispatch = useAppDispatch();
    const { agentId } = useParams();
    const navigate = useNavigate();
    const { goBack } = useNavigationHandler({ fallbackPath: "/dashboard/workforce" });

    const [agentIsActive, setAgentIsActive] = useState<boolean>(false);
    const [agentDetails, setAgentDetails] = useState<Record<string, any>>({});
    const [configuration, setConfiguration] = useState<Record<string, any>>({
        syncFrequency: "",
        needsApproval: false,
        generateReportsFrequency: "",
        generalInstructions: "",
        collaboratorIds: [],
    });
    // generalInstructions
    const { data: teamList, handleDebouncedChange, isFetching: isFetchingTeamList } = useGetTeam();

    const { fetchSingleAgentSuccess, fetchingSingleAgent, updatingAiTeammate } = useAppSelector(
        (state) => state?.workforce
    );

    useEffect(() => {
        if (agentId) {
            dispatch(workforceActions.getSingleAgent(agentId));
        }
    }, [agentId, dispatch]);

    useEffect(() => {
        if (fetchSingleAgentSuccess) {
            setAgentIsActive(
                typeof fetchSingleAgentSuccess?.activeAgent === "object" &&
                    fetchSingleAgentSuccess?.activeAgent?._id
            );
            setAgentDetails(fetchSingleAgentSuccess);
            setConfiguration({
                ...fetchSingleAgentSuccess?.activeAgent?.configuration,
                collaboratorIds:
                    fetchSingleAgentSuccess?.activeAgent?.configuration?.collaboratorIds?.length > 0
                        ? fetchSingleAgentSuccess?.activeAgent?.configuration?.collaboratorIds
                        : [],
            });

            dispatch(workforceActions.resetGetSingleAgentSuccess());
        }
    }, [dispatch, fetchSingleAgentSuccess]);

    const handleSettings = () => {
        const body = {
            configuration: {
                needsApproval: configuration?.needsApproval,
                collaboratorIds:
                    configuration?.collaboratorIds?.length > 0
                        ? configuration?.collaboratorIds
                        : [],
                ...(configuration?.generalInstructions && {
                    generalInstructions: configuration?.generalInstructions,
                }),
                ...(configuration?.syncFrequency && {
                    syncFrequency: configuration?.syncFrequency,
                }),
                ...(configuration?.generateReportsFrequency && {
                    generateReportsFrequency: configuration?.generateReportsFrequency,
                }),
            },
        };

        if (agentIsActive) {
            dispatch(workforceActions.updateAiTeammate(body, agentDetails?.activeAgent?._id));
        }
    };

    return (
        <div>
            <div className="sticky top-[-20px] z-[1200] bg-white ">
                <div className="rounded-t-[8px]">
                    <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100 text-sm ">
                        <div className="flex items-center space-x-1.5 text-slate-400 text-sm font-rocGroteskMedium">
                            <i
                                onClick={() => {
                                    goBack();
                                }}
                                className="ri-arrow-left-s-line text-lg mt-[-2px] text-slate-400 py-0 px-1 rounded-full bg-slate-100 cursor-pointer"
                            ></i>
                            <span className="">AI teammate</span>
                            <span className="">/ Email Order Processing</span>

                            <span className="text-slate-900 font-rocGroteskMedium">/ Astra</span>
                        </div>
                        <div className="flex items-center space-x-3">
                            <Button
                                btnText="Close"
                                btnClassname="!px-4 !py-2.5 !bg-tradeally-neutral-20 !w-fit"
                                disabled={false}
                                onClick={() => {
                                    navigate("/dashboard/workforce");
                                }}
                            />
                            <Button
                                btnText={"Update Settings"}
                                btnPermission={[]}
                                type="button"
                                isLoading={updatingAiTeammate}
                                onClick={() => {
                                    handleSettings();
                                }}
                                disabled={!agentIsActive}
                                btnClassname="!px-4 !py-2.5 !w-fit"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="">
                <Tabs setActiveTab={setActiveTab} activeTab={activeTab} />
            </div>
            <div className=" bg-[url('https://storage.googleapis.com/heysynth_files/synth_webapp/Background%20pattern%20-%20dots.svg')] bg-repeat bg-cover ">
                {fetchingSingleAgent ? (
                    <div className=" h-[500px] flex items-center justify-center">
                        <Loader />
                    </div>
                ) : (
                    <div className=" font-rocGroteskMedium flex flex-col items-center  w-full  pt-6">
                        <div className="bg-white w-full flex flex-col items-center pb-20">
                            <div className="py-8 lg:min-w-[720px] bg-white">
                                <div className="border-b border-b-slate-100 pb-6 space-y-6">
                                    <div className="">
                                        <p className="text-[#000000] text-base">
                                            General instruction
                                        </p>
                                        <p className="text-sm text-slate-500">
                                            Provide background information for this AI Team-mate to
                                            keep in mind at all times.
                                        </p>
                                    </div>
                                    <TextareaInput
                                        name="generalInstructions"
                                        value={configuration?.generalInstructions}
                                        onChange={(e) => {
                                            setConfiguration({
                                                ...configuration,
                                                generalInstructions: e.target.value,
                                            });
                                        }}
                                        rows={5}
                                        placeholder={"Add context"}
                                        required={false}
                                    />
                                </div>
                                <div className="mt-6 space-y-6">
                                    <p className="text-[#000000] text-base">Notifications</p>
                                    <div className="">
                                        <p className="text-[#000000] text-base">
                                            Get notified when a task fails
                                        </p>
                                        <div className="flex items-center gap-2 justify-between">
                                            <p className="text-sm text-slate-500">
                                                Receive a notification when failures occur in runs
                                                of this agent task
                                            </p>
                                            <ToggleInput
                                                checked={configuration?.needsApproval}
                                                name="needsApproval"
                                                onChange={(e) => {
                                                    setConfiguration({
                                                        ...configuration,
                                                        needsApproval: e.target.checked,
                                                    });
                                                }}
                                                className="w-slider before:!h-4 before:!w-4 h-5 w-[30px] before:left-[2px] rounded-[30px]"
                                            />
                                        </div>
                                    </div>
                                </div>

                                {(agentDetails?.type === "marketingCampaign" ||
                                    agentDetails?.type === "EDIAssistant" ||
                                    agentDetails?.type === "InventoryManagement") && (
                                    <>
                                        <div className="mt-6 pt-6 border-t border-t-slate-100">
                                            <div className="">
                                                <p className="text-[#000000] text-base mb-2">
                                                    Choose team member(s) to alert about potential
                                                    inventory incidents.
                                                </p>
                                                <MultiselectInput
                                                    value={configuration?.collaboratorIds}
                                                    name="collaboratorIds"
                                                    placeholder={"Select collaborator"}
                                                    handleChange={(name, value, valueArr) => {
                                                        setConfiguration((prev) => ({
                                                            ...prev,
                                                            [name]: valueArr,
                                                        }));
                                                    }}
                                                    searchLoading={isFetchingTeamList}
                                                    handleInputChange={handleDebouncedChange}
                                                    isRequired={false}
                                                    dropdownOptions={teamList?.map((team) => {
                                                        return {
                                                            label: team?.fullName || team?.email,
                                                            value: team?._id,
                                                        };
                                                    })}
                                                />
                                            </div>
                                        </div>
                                        <div className="mt-6 pt-6 border-t border-t-slate-100">
                                            <p className="text-[#000000] text-base">
                                                Extract information
                                            </p>
                                            <p className="text-sm text-slate-500 mb-2">
                                                The agent visits the EDI website and downloads the
                                                latest purchase orders.
                                            </p>

                                            <SelectInput
                                                value={configuration?.syncFrequency}
                                                name="syncFrequency"
                                                placeholder={"Select frequency"}
                                                handleChange={(name, value) => {
                                                    setConfiguration((prev) => {
                                                        return {
                                                            ...prev,
                                                            syncFrequency: value,
                                                        };
                                                    });
                                                }}
                                                dropdownOptions={[
                                                    {
                                                        label: "Daily",
                                                        value: "daily",
                                                    },
                                                    {
                                                        label: "Weekly",
                                                        value: "weekly",
                                                    },
                                                    {
                                                        label: "Monthly",
                                                        value: "monthly",
                                                    },
                                                    {
                                                        label: "Yearly",
                                                        value: "yearly",
                                                    },
                                                ]}
                                            />
                                        </div>{" "}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Settings;
